// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__HrrcW","rootSuccess":"CompleteLink_rootSuccess__5sPaa","rootFailure":"CompleteLink_rootFailure__3oHxc","isDisabled":"CompleteLink_isDisabled__2HPJ1"};